module.exports = __webpack_public_path__ + "img/pro.5ef46f7c.png";